<template>
  <div>
    <div class="table-wapper" ref="toolbarTable">
        <table :key="report.items && (report.items || []).length > 0 ? (report.items || [])[0].id : keyTable">
        <thead>
            <tr class="tittle-table">
            <th>{{ $t('order_number') }}</th>
            <th>{{ $t('created_at') }}</th>
            <th>{{ $t('outlet_register') }}</th>
            <th>{{ $t('customer_name') }}</th>
            <th v-if="$route.name === 'salesOrder'">{{ $t('sub_total_tax_included') }}</th>
            <th v-if="$route.name === 'salesOrder'">{{ $t('sub_total_tax_excluded') }}</th>
            <th class="min-width">{{ $t('total') }}</th>
            <th v-if="$route.name === 'paymentStatus' || $route.name === 'orderStatus' || $route.name === 'salesOrder'" class="min-width">{{ $t('tax') }}</th>
            <th v-if="$route.name === 'salesOrder'" class="min-width">{{ $t('refund') }}</th>
            <th v-if="$route.name === 'orderStatus' || $route.name === 'salesOrder'" class="min-width">{{ $t('discount') }}</th>
            <th v-if="getPlatform() === 'msi' && $route.name !== 'tippings' && $route.name !== 'salesOrder'">{{ $t('order_status') }}</th>
            <th v-if="$route.name === 'paymentStatus'">{{ $t('payment_status') }}</th>
            <th v-if="$route.name === 'paymentStatus'">{{ $t('fulfillment_status') }}</th>
            <th v-if="$route.name === 'tippings'">{{ $t('sale_person') }}</th>
            <th v-if="$route.name === 'tippings'">{{ $t('tipping_amount') }}</th>
            <th v-if="$route.name === 'tippings'">{{ $t('tipping_at') }}</th>
            <th v-if="$route.name === 'salesOrder' && colsData.includes('tipping')" class="min-width">{{ $t('tip') }}</th>
            <th v-if="$route.name === 'salesOrder' && colsData.includes('charge')" class="min-width">{{ $t('charge') }}</th>
            <th v-if="$route.name === 'paymentStatus' || $route.name === 'orderStatus'">{{ $t('payment_status_updated_at') }}</th>
            <th v-if="($route.name === 'paymentStatus' || $route.name === 'orderStatus') && getPlatform() !== 'magento2'">{{ $t('order_status_updated_at') }}</th>
            <th v-if="(isShowReferenceNumber || false) && $route.name === 'paymentStatus'">{{$t('payment_info')}}</th>
            <th v-if="$route.name === 'orderStatus'">{{ $t('order_note') }}</th>
            <th v-if="$route.name === 'orderStatus'">{{ $t('staff_note') }}</th>
            <div v-frag v-if="Number(report.paymentsCount || 0) > 0 && $route.name === 'salesOrder'">
              <div v-frag v-for="index in Number(report.paymentsCount || 0)" :key="index">
                <th>{{$t('payment_method')}} {{ index }} {{$t('name')}}</th>
                <th>{{$t('payment_method')}}  {{ index }} {{$t('amount')}}</th>
                <th>{{$t('payment_method')}}  {{ index }} {{$t('ref')}}#</th>
              </div>
            </div>
            </tr>
        </thead>
        <tbody v-if="itemsLength() > 0">
            <!-- <tr class="total-rows total_report">
            <td>{{ $t('summary') }}</td>
            <td class="text-right" v-for="(colName, index) in colsData" :key="index">{{ totalPriceByCol(colName.key || colName) }}</td>
            </tr> -->
            <tr v-for="(item, index) in Object.keys(report.items)" :key="index">
            <td class="text-normal">{{ report.items[item].posOrderId || report.items[item].name || report.items[item].orderNumber }}</td>
            <td>{{ formartDate(report.items[item].createdAt || report.items[item].orderCreatedAt) }}</td>
            <td>{{ getOutletRegisterName(report.items[item].outletId || report.items[item].outletName || '', report.items[item].registerId) }}</td>
            <td v-if="$route.name === 'tippings'">{{ report.items[item].firstName }} {{ report.items[item].lastName }}</td>
            <td v-else>{{ getCustomerName(report.items[item].customer) }}</td>
            <td v-if="$route.name === 'salesOrder'">{{ formatTotal(getCurrentTotalPrice(report.items[item].subtotalIncTax, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td v-if="$route.name === 'salesOrder'">{{ formatTotal(getCurrentTotalPrice(report.items[item].subtotalExTax, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td>{{ formatTotal(getCurrentTotalPrice(report.items[item].totalPrice || report.items[item].orderTotalPrice, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td v-if="$route.name === 'paymentStatus' || $route.name === 'orderStatus' || $route.name === 'salesOrder'">{{ formatTotal(getCurrentTotalPrice(report.items[item].totalTax, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td v-if="$route.name === 'salesOrder'">{{ formatTotal(getCurrentTotalPrice(report.items[item].refundedTotalPrice, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td v-if="$route.name === 'orderStatus' || $route.name === 'salesOrder'">{{ formatTotal(getCurrentTotalPrice(report.items[item].totalDiscounts, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td class="text-capitalize" v-if="getPlatform() === 'msi' && $route.name !== 'tippings' && $route.name !== 'salesOrder'">{{ getStatus(report.items[item].state || '') }}</td>
            <td class="text-capitalize" v-if="$route.name === 'paymentStatus'">{{ getPaymentStatus(report.items[item].status || '') }}</td>
            <td class="text-capitalize" v-if="$route.name === 'paymentStatus'">{{ getFulfillmentStatus(report.items[item].fulfillmentStatus || '') }}</td>
            <td class="text-capitalize" v-if="$route.name === 'tippings'">{{ report.items[item].salesmanName || report.items[item].cashierName }}</td>
            <td v-if="$route.name === 'tippings'">{{ formatTotal(getCurrentTotalPrice(report.items[item].amount || 0, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td class="text-capitalize" v-if="$route.name === 'tippings'">{{ formartDate(report.items[item].tippedCreatedAt) }}</td>
            <td v-if="$route.name === 'salesOrder' && colsData.includes('tipping')">{{ formatTotal(getCurrentTotalPrice(report.items[item].totalTip, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td v-if="$route.name === 'salesOrder' && colsData.includes('charge')">{{ formatTotal(getCurrentTotalPrice(report.items[item].totalPaid, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) }}</td>
            <td class="text-capitalize" v-if="report.items[item].paymentStatusUpdatedAt != null && ($route.name === 'paymentStatus' || $route.name === 'orderStatus')">{{ formartDate(report.items[item].paymentStatusUpdatedAt) }}</td>
            <td class="text-capitalize" v-if="report.items[item].orderStatusUpdatedAt != null && ($route.name === 'paymentStatus' || $route.name === 'orderStatus') && getPlatform() !== 'magento2'">{{ formartDate(report.items[item].orderStatusUpdatedAt) }}</td>
            <td v-if="(isShowReferenceNumber || false) && $route.name === 'paymentStatus'">
              <div v-for="(ref, index) in report.items[item].paymentInfo || []" :key="ref.id">
                <p class="payment-ref">{{$t('Payment')}} {{ index + 1 }}: {{ ref.paymentName }} - ref: {{ ref.referenceNumber || '' }}</p>
              </div>
            </td>
            <td class="pre-line" v-if="$route.name === 'orderStatus'" :class="`${report.items[item].orderNote ? 'report_note' : ''}`">{{ report.items[item].orderNote || '' }}</td>
            <td class="pre-line" v-if="$route.name === 'orderStatus'" :class="`${report.items[item].staffNote ? 'report_note' : ''}`">{{ report.items[item].staffNote || '' }}</td>
            <div v-frag v-if="Number(report.paymentsCount || 0) > 0 && $route.name === 'salesOrder'">
              <div v-frag v-for="(payment, index) in (report.items[item].paymentInfo || [])" :key="index">
                <td>{{ `${payment.paymentName || ''} ${getCurrentType(payment.type || '')}` || '' }}</td>
                <td>{{ formatTotal(getCurrentTotalPrice(payment.amount, report.items[item].currencyExchangeRate), report.items[item].currencyExchangeRate, report.items[item].presentmentCurrency) || '' }}</td>
                <td>{{ payment.referenceNumber || '' }}</td>
              </div>
              <div v-frag v-for="index in Number(report.paymentsCount || 0) - (report.items[item].paymentInfo || []).length" :key="`none_${index}`">
                <td>{{ '' }}</td>
                <td>{{ '' }}</td>
                <td>{{ '' }}</td>
              </div>
            </div>
          </tr>
        </tbody>
        <tbody v-if="itemsLength() <= 0">
            <tr class="no-data">
            <td colspan="12">{{$t('no_data')}}</td>
            </tr>
        </tbody>
        </table>
    </div>
    <div class="pagination" v-if="count_items / getQuery.limit > 1 && report.items">
      <Pagination :page="getQuery.page - 1" :total="count_items" :limit="getQuery.limit" @getDataTable="getDataTable"/>
    </div>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import reportType from '@/config/reportType'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import orderStatus from '@/constants/orderStatus'
import paymentStatus from '@/constants/paymentStatus'
import fulfillmentStatus from '@/constants/fulfillmentStatus'
import Pagination from '@/components/UiPagination'
import i18n from '@/i18n'
export default {
  name: 'UiTableOrderReport',
  components: {
    Pagination
  },
  props: {
    report: {
      type: Object,
      default: () => {}
    },
    colsData: {
      type: Array,
      default: () => []
    },
    isShowReferenceNumber: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      groupedData: [],
      conferenceDay: [],
      reportType: {
        productSold: 'productSold',
        productSoldByCategory: 'productSoldByCategory',
        payment: 'payment'
      },
      keyTable: 0
    }
  },
  computed: {
    ...mapGetters({
      getListOutLet: 'outlet/getListOutLet',
      getCustomStatuses: 'order/getCustomStatuses',
      count_items: 'report/getCountItems',
      getQuery: 'report/getQuery',
      getIsChangeStore: 'report/getIsChangeStore'
    })
  },
  watch: {
    getQuery: function (news, old) {
      if (news.page !== old.page) {
        this.$refs.toolbarTable.scrollTop = 0
      }
      this.keyTable = Math.random()
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      getTippingReport: 'report/getTippingReportDataByStore',
      setChangeStore: 'report/setChangeStore'
    }),
    moment (any) {
      return moment(any)
    },
    getName () {
      return this.$route.currentRoute.name
    },
    getTableData (reportItem, col) {
      if (typeof reportItem === 'string') {
        return this.formatTotal(this.report.items[reportItem][col])
      }
      if (typeof reportItem[col] === 'string' || typeof reportItem[col] === 'number') {
        return this.formatTotal(reportItem[col])
      }
      return col.key === 'orderCount'
        ? reportItem[col.key] || 0
        : col.key === 'avgItemCount'
          ? reportItem[col.key]
            ? parseFloat(reportItem[col.key]).toFixed(2)
            : 0
          : this.formatTotal(reportItem[col.key])
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    getCurrentTotalPrice (total, currencyExchangeRate = null) {
      // data of order multipled by rate from BE (Must be that from BE)
      if (currencyExchangeRate && total) {
        return Number(total) / Number(currencyExchangeRate)
      }
      return total
    },
    getCurrentType (type) {
      switch (type) {
        case 'refund':
          return '(Refunded)'
        case 'change':
          return '(Change)'
        default:
          return ''
      }
    },
    onDefaultFilter (day, type) {
      this.day = day
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    formartDate (date) {
      if (date.length < 8) {
        if (date.toLowerCase().includes('week')) {
          return date.toLowerCase().replace('week', i18n.t('week'))
        }
        return date
      }
      const dateRes = new Date(moment(date).toDate())

      return i18n.d(dateRes, 'long')
    },
    getPlatform () {
      return getItemByLocalStorage(localStorageKey.CURRENT_PLATFORM)
    },
    formatTotal (total, currencyExchangeRate = null, presentmentCurrency = null) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY) || {}
      const toCurrencyKey = 'toCurrency'
      const toCurrency = currentCurrent[toCurrencyKey]
      var rate = presentmentCurrency && currencyExchangeRate && (toCurrency === presentmentCurrency) ? currencyExchangeRate : (currentCurrent?.rate || '1')
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(rate)).toFixed(2), { maxFraction: 2 })}`
    },
    totalPaymentByCol (colName) {
      if (this.report === undefined || this.report.items === undefined) {
        return this.formatTotal(0)
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += parseFloat(this.report.items[item][colName] ? parseFloat(this.report.items[item][colName]) : 0)
      })

      return this.formatTotal(total)
    },
    totalPriceByCol (colName) {
      if (this.report === undefined || this.report.items === undefined) {
        return this.formatTotal(0)
      }

      if (colName === 'avgOrderValue') {
        let totalRevenue = 0
        let totalOrder = 0
        Object.keys(this.report.items).forEach(item => {
          totalRevenue += parseFloat(this.report.items[item].totalRevenue ? parseFloat(this.report.items[item].totalRevenue) : 0)
          totalOrder += parseFloat(this.report.items[item].orderCount ? parseFloat(this.report.items[item].orderCount) : 0)
        })
        return this.formatTotal(totalRevenue / totalOrder)
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += parseFloat(this.report.items[item][colName] ? parseFloat(this.report.items[item][colName]) : 0)
      })
      if (colName === 'avgOrderValue' || colName === 'avgItemCount') {
        const avgValue = (total / Object.keys(this.report.items).length).toFixed(2)
        return colName === 'avgOrderValue' ? this.formatTotal(avgValue) : avgValue
      }
      return colName === 'orderCount' ? total : this.formatTotal(total)
    },
    itemsLength () {
      if (this.report === undefined || this.report.items === undefined) {
        return 0
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += 1
      })
      return total
    },
    getOutletRegisterName (outletId, registerId) {
      const outlet = this.getListOutLet.find((outlet) => outlet.id === outletId)
      if (outletId === 'Online') {
        return 'Online'
      }
      if (outlet) {
        const outletName = outlet.name

        const register = (outlet.registers || []).find(registerObj => registerObj.id === registerId)

        return outletName + (register ? (' - ' + register.name) : '')
      }
      return ''
    },
    getCustomerName (customer) {
      if (!customer) {
        return ''
      }
      return customer.firstName + (customer.lastName ? ` ${customer.lastName}` : '')
    },
    getStatus (code) {
      const customStatus = (this.getCustomStatuses || []).find(status => status.value === code && status.is_published)
      if (customStatus) {
        return customStatus.label
      }
      return orderStatus[code] || code.split('_').join(' ')
    },
    getPaymentStatus (code) {
      return paymentStatus[code] || code.split('_').join(' ')
    },
    getFulfillmentStatus (code) {
      return fulfillmentStatus[code] || code.split('_').join(' ')
    },
    groupBy (array, fn) {
      const result = {}
      array.forEach((item) => {
        const key = fn(item)

        if (!result[key]) {
          result[key] = []
        }
        result[key].push(item)
      })
      return result
    },
    getDataTable (currentPage) {
      if (this.$route.name === 'tippings') {
        this.getTippingReport({
          type: reportType.tippings,
          query: {
            ...this.query,
            page: currentPage
          }
        })
      } else {
        this.getReport({
          type: reportType.orders,
          query: {
            ...this.query,
            page: currentPage
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wapper {
  overflow-x: auto;
  table {
    width: 100%;
    color: #333;
    border: 0 solid #e4e3e4;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #fff;
    border-width: 1px 0 0 1px;
    border-radius: 7px;
    letter-spacing: 0;
    font-size: 15px;
    font-weight: 400;
    td,
    tr,
    th {
      border: 1px solid #e4e3e4;
      padding: 15px 5px;
      vertical-align: middle;
    }
    .min-width{
      min-width: 100px;
    }
    tr td:first-child {
      text-transform: capitalize;
    }
    .text-normal {
      text-transform: none !important;
    }
    .tittle-table {
      color: #fff;
      background-color: #92a1ab;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      th {
        font-size: 16px;
        font-weight: bold;
        text-transform: capitalize;
        border-bottom-width: 1px;
        text-align: center;
        padding: 15px 5px;
        border: 1px solid #e4e3e4;
        vertical-align: middle;
      }
    }
    .payment-ref {
      padding-bottom: 6px;
    }
    .text-center {
      text-align: center;
    }
    .text-right {
      text-align: right;
    }
    .min_width {
      min-width: 150px;
    }
    .report_name {
      min-width: 230px;
    }
    .report_note {
      width: 150px;
    }
    .report_total {
      width: 100px;
    }
    .text-capitalize {
      text-transform: capitalize;
    }
    .pre-line {
      white-space: pre-line;
    }
  }
}
</style>
